// 请求方法相关
import { axios } from './request';

//post
export function postAction(url, token, parameter, withCredentials=true) {
  return axios({
    url: url,
    method:'post' ,
    data: parameter,
    withCredentials,
    headers: {
      "Authorization": 'Bearer ' + token
    }
  })
}


//put
export function putAction(url, token, parameter, withCredentials=true) {
  return axios({
    url: url,
    method:'put',
    data: parameter,
    withCredentials,
    headers: {
      "Authorization": 'Bearer ' + token
    }
  })
}

//get
export function getAction(url, token, parameter, withCredentials=true) {
  console.log(url);
  return axios({
    url: url,
    method: 'get',
    params: parameter,
    withCredentials,
    headers: {
      "Authorization": 'Bearer ' + token
    }
  })
}

//deleteAction
export function deleteAction(url, token, parameter, withCredentials=true) {
  return axios({
    url: url,
    method: 'delete',
    params: parameter,
    withCredentials,
    headers: {
      "Authorization": 'Bearer ' + token
    }
  })
}

// 下载与上传文件
export function downFile(url, token, parameter, withCredentials=true){
  return axios({
    url: url,
    params: parameter,
    method:'get' ,
    responseType: 'blob',
    withCredentials,
    headers: {
      "Authorization": 'Bearer ' + token
    }
  })
}
export function uploadFile (url, token, parameter, withCredentials=true) {
  return axios({
    url: url,
    data: parameter,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    withCredentials,
    headers: {
      "Authorization": 'Bearer ' + token
    }
  })
};



// WEBPACK FOOTER //
// ./src/packages/chatBox/components/manage.js